import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { ParamMap, Router, NavigationExtras, ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { isPlatformServer } from '@angular/common';
import { BehaviorSubject, of } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { LangService } from '../lang/lang.service';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';
import { ConfigService } from '../config/config.service';

@Injectable()
export class PostService {

  private overlayStatus = new BehaviorSubject<any>({});
  overlay = this.overlayStatus.asObservable();

  constructor(private http: HttpClient, public router: Router,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platform: Object,
    private lang: LangService,
    private authService: AuthenticationService,
    private conf: ConfigService) { }

  getPage(postId): Observable<any> {
    const options = { params: new HttpParams({}) };
    if (postId) {
      const onlyNumbers = new RegExp('^[0-9]*$');
      if (onlyNumbers.test(postId)) {
        options.params = options.params.append('id', postId);
      } else {
        options.params = options.params.append('configuration_name', postId);  
      }
      options.params = options.params.append('language_code', this.lang.getCurrentLang());
      options.params = options.params.append('image_size', '2048');
      options.params = options.params.append('platform', 'web');
      options.params = options.params.append('country_code', this.conf.getUserDefaultCountry() ?
       this.conf.getUserDefaultCountry().country_code : 'GB');
    } else {
      return;
    }
    const getPostUrl: any = environment.apiUrl.baseUrl + environment.apiUrl.pages.post.content;
    const POST_KEY = makeStateKey('post-' + postId);
    if (this.transferState.hasKey(POST_KEY)) {
      const post = this.transferState.get(POST_KEY, null);
      this.transferState.remove(POST_KEY);
      return of(post);
    } else {
      return this.http
        .get(getPostUrl, options)
        .pipe(map(
          (resp: any) => {
            if (isPlatformServer(this.platform)) {
              this.transferState.set(POST_KEY, resp);
            }
            return resp;
          },
          err => {
            if (err.status === 404) {
              this.router.navigate(['/404'], { replaceUrl: true, queryParams: { page: this.router.url } });
            }
            return err;
          }
        ));
    }
  }

  getCarousel(page_number, destinationID?): Observable<any> {
    const options = { params: new HttpParams({}) };
    options.params = options.params.append('language_code', this.lang.getCurrentLang());
    options.params = options.params.append('country_code', this.conf.getUserDefaultCountry() ?
     this.conf.getUserDefaultCountry().country_code : 'GB');
    options.params = options.params.append('image_size', '2048');
    options.params = options.params.append('platform', 'web');
    if (page_number) {
      options.params = options.params.append('page', page_number);
    }
    if (destinationID) {
      options.params = options.params.append('destination_id', destinationID);
    }
    const getActivityCarouselUrl: any = environment.apiUrl.baseUrl + environment.apiUrl.pages.post.carousel;
    return this.http
      .get(getActivityCarouselUrl, options)
      .pipe(map(
        resp => {
          return resp;
        },
        err => {
          if (err.status === 404) {
            this.router.navigate(['/404'], { replaceUrl: true, queryParams: { page: this.router.url } });
          }
          return err;
        }
      ));
  }

  getPartnerCarousel(page_number, partnerName: string, destinationID?): Observable<any> {
      const options = { params: new HttpParams({}) };
      options.params = options.params.append('language_code', this.lang.getCurrentLang());
      options.params = options.params.append('country_code', this.conf.getUserDefaultCountry() ?
          this.conf.getUserDefaultCountry().country_code : 'GB');
      options.params = options.params.append('image_size', '2048');
      options.params = options.params.append('platform', 'web');
      if (page_number) {
          options.params = options.params.append('page', page_number);
      }
      if (destinationID) {
          options.params = options.params.append('destination_id', destinationID);
      }

      let partnerWithChannelArr = this.conf.configurations.app_config_partners_channel_ids.split(',').find(el => {
          if(el.includes(partnerName)){
              return true;
          }
      }).split(':');

      const partnerChannelId = partnerWithChannelArr[1];

      options.params = options.params.append('channel_id', partnerChannelId);

      const getActivityCarouselUrl: any = environment.apiUrl.baseUrl + environment.apiUrl.pages.post.carousel;
      return this.http
          .get(getActivityCarouselUrl, options)
          .pipe(map(
              resp => {
                  return resp;
              },
              err => {
                  if (err.status === 404) {
                      this.router.navigate(['/404'], { replaceUrl: true, queryParams: { page: this.router.url } });
                  }
                  return err;
              }
          ));
  }

  changeOverlayStatus(res) {
    this.overlayStatus.next(res);
  }

  deleteSavedPost(id): Observable<any> {
    const deletePostUrl = environment.apiUrl.baseUrl + environment.apiUrl.pages.post.userPost;
    const options = { params: new HttpParams({}), headers: new HttpHeaders({}) };
    options.headers = options.headers.append('Authorization', 'Bearer ' + this.authService.getUserToken());
    options.params = options.params.append('user_post_id', id);
    return this.http
      .delete(deletePostUrl, options)
      .pipe(map(
        response => {
          return response;
        },
        error => {
          return error;
        }
      ));
  }

  getDirectPaymentBlock(buttonId): Observable<any> {
    const getDirectPaymentBlockURL = environment.apiUrl.baseUrl + environment.apiUrl.pages.post.directPayment;
    const options = {params: new HttpParams({})};
    options.params = options.params.append('id', buttonId);
    return this.http
    .get(getDirectPaymentBlockURL, options)
    .pipe(map(
      response => {
        return response;
      },
      error => {
        return error;
      }
    ));
  }
}
